// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StepTwo_cardContainer__Wm3ga {
  margin-top: 20px;
  width: fit-content;
}
.StepTwo_selectRole__aloeI {
  margin-top: 30px;
  margin-bottom: 100px;
}
.StepTwo_column__sfKhP {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  justify-content: center;
  gap: 12px;
}
.StepTwo_subLabel__UTzoV {
  font-weight: 500;
  line-height: 22px;
  color: #7e818c;
}
.StepTwo_mainLabel__zimYg {
  font-weight: 600;
  line-height: 22px;
  color: #4d4e4e;
}
.StepTwo_mainLabel__zimYg,
.StepTwo_roleHeading__JKcrc,
.StepTwo_checkboxLabel__R4rtP,
.StepTwo_subLabel__UTzoV,
.StepTwo_radioLabel__qCajm,
.StepTwo_cancelButton__QSdof,
.StepTwo_addButton__7aUgm {
  font-family: Inter;
  font-size: 16px;
  letter-spacing: -0.001em;
  text-align: left;
}

.StepTwo_radioLabel__qCajm {
  font-weight: 500;
  line-height: 22px;
  color: #6e6e6e;
  display: flex;
  align-items: center;
  margin-top: 16px;
  cursor: pointer;
}
.StepTwo_radio__Hk0Ne {
  appearance: none;
  width: 24px;
  height: 24px;
  border: 2px solid #e2e2e2;
  border-radius: 50%;
  margin-right: 8px;
  cursor: pointer;
  box-sizing: border-box;
}
.StepTwo_radio__Hk0Ne:hover {
  border: 2px solid #cb9c2d;
  cursor: pointer;
}
.StepTwo_radio__Hk0Ne:checked {
  border: 1px solid #cb9c2d;
  background-color: #cb9c2d;
}

.StepTwo_roleHeading__JKcrc,
.StepTwo_checkboxLabel__R4rtP {
  font-weight: 500;
  line-height: 22px;
  color: #6e6e6e;
}
.StepTwo_roleHeading__JKcrc {
  margin-bottom: 10px;
}
.StepTwo_checkbox__vp18V {
  appearance: none;
  width: 16px;
  height: 16px;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid #e2e2e2;
  position: relative;
  background: #e2e2e2;
  vertical-align: middle;
  margin-right: 8px;
}
.StepTwo_checkbox__vp18V:checked::before {
  content: "✔";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 12px;
  color: #ffffff;
}
.StepTwo_checkbox__vp18V:checked {
  background: #cb9c2d;
}
.StepTwo_checkboxRow__XSWEI {
  margin-bottom: 10px;
}
.StepTwo_buttonContainer__Gp7DM {
  position: fixed;
  bottom: 0;
  width: 80%;
  display: flex;
  justify-content: center;
  padding: 10px;
  gap: 20px;
}
.StepTwo_cancelButton__QSdof,
.StepTwo_addButton__7aUgm {
  width: 212px;
  height: 52px;
  padding: 8px 16px 8px 16px;
  border-radius: 4px;
  gap: 8px;
  font-weight: 600;
  line-height: 22px;
  text-align: center;
  border: none;
  cursor: pointer;
}
.StepTwo_cancelButton__QSdof {
  background: #ebebeb;
  color: #808080;
}
.StepTwo_addButton__7aUgm {
  color: #ffffff;
  background: #cb9c2d;
}
.StepTwo_disabledButton__yZuhY {
  cursor: not-allowed;
  background: #cbba92;
}
`, "",{"version":3,"sources":["webpack://./src/scenes/IPDTeam/DodajDjelatnika/ContentComponents/AddUserSecondStep/StepTwo.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;AACA;;;;;;;EAOE,kBAAkB;EAClB,eAAe;EACf,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,SAAS;AACX;AACA;;EAEE,YAAY;EACZ,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB","sourcesContent":[".cardContainer {\n  margin-top: 20px;\n  width: fit-content;\n}\n.selectRole {\n  margin-top: 30px;\n  margin-bottom: 100px;\n}\n.column {\n  display: flex;\n  flex-direction: column;\n  align-items: baseline;\n  justify-content: center;\n  gap: 12px;\n}\n.subLabel {\n  font-weight: 500;\n  line-height: 22px;\n  color: #7e818c;\n}\n.mainLabel {\n  font-weight: 600;\n  line-height: 22px;\n  color: #4d4e4e;\n}\n.mainLabel,\n.roleHeading,\n.checkboxLabel,\n.subLabel,\n.radioLabel,\n.cancelButton,\n.addButton {\n  font-family: Inter;\n  font-size: 16px;\n  letter-spacing: -0.001em;\n  text-align: left;\n}\n\n.radioLabel {\n  font-weight: 500;\n  line-height: 22px;\n  color: #6e6e6e;\n  display: flex;\n  align-items: center;\n  margin-top: 16px;\n  cursor: pointer;\n}\n.radio {\n  appearance: none;\n  width: 24px;\n  height: 24px;\n  border: 2px solid #e2e2e2;\n  border-radius: 50%;\n  margin-right: 8px;\n  cursor: pointer;\n  box-sizing: border-box;\n}\n.radio:hover {\n  border: 2px solid #cb9c2d;\n  cursor: pointer;\n}\n.radio:checked {\n  border: 1px solid #cb9c2d;\n  background-color: #cb9c2d;\n}\n\n.roleHeading,\n.checkboxLabel {\n  font-weight: 500;\n  line-height: 22px;\n  color: #6e6e6e;\n}\n.roleHeading {\n  margin-bottom: 10px;\n}\n.checkbox {\n  appearance: none;\n  width: 16px;\n  height: 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  border: 1px solid #e2e2e2;\n  position: relative;\n  background: #e2e2e2;\n  vertical-align: middle;\n  margin-right: 8px;\n}\n.checkbox:checked::before {\n  content: \"✔\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  font-size: 12px;\n  color: #ffffff;\n}\n.checkbox:checked {\n  background: #cb9c2d;\n}\n.checkboxRow {\n  margin-bottom: 10px;\n}\n.buttonContainer {\n  position: fixed;\n  bottom: 0;\n  width: 80%;\n  display: flex;\n  justify-content: center;\n  padding: 10px;\n  gap: 20px;\n}\n.cancelButton,\n.addButton {\n  width: 212px;\n  height: 52px;\n  padding: 8px 16px 8px 16px;\n  border-radius: 4px;\n  gap: 8px;\n  font-weight: 600;\n  line-height: 22px;\n  text-align: center;\n  border: none;\n  cursor: pointer;\n}\n.cancelButton {\n  background: #ebebeb;\n  color: #808080;\n}\n.addButton {\n  color: #ffffff;\n  background: #cb9c2d;\n}\n.disabledButton {\n  cursor: not-allowed;\n  background: #cbba92;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardContainer": `StepTwo_cardContainer__Wm3ga`,
	"selectRole": `StepTwo_selectRole__aloeI`,
	"column": `StepTwo_column__sfKhP`,
	"subLabel": `StepTwo_subLabel__UTzoV`,
	"mainLabel": `StepTwo_mainLabel__zimYg`,
	"roleHeading": `StepTwo_roleHeading__JKcrc`,
	"checkboxLabel": `StepTwo_checkboxLabel__R4rtP`,
	"radioLabel": `StepTwo_radioLabel__qCajm`,
	"cancelButton": `StepTwo_cancelButton__QSdof`,
	"addButton": `StepTwo_addButton__7aUgm`,
	"radio": `StepTwo_radio__Hk0Ne`,
	"checkbox": `StepTwo_checkbox__vp18V`,
	"checkboxRow": `StepTwo_checkboxRow__XSWEI`,
	"buttonContainer": `StepTwo_buttonContainer__Gp7DM`,
	"disabledButton": `StepTwo_disabledButton__yZuhY`
};
export default ___CSS_LOADER_EXPORT___;
